// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"34":"vin","242":"iWantService","449":"notFound","631":"contact"}[chunkId] + "." + {"34":"a7f6003c","242":"da8e8120","449":"ce0c4217","631":"b767f233"}[chunkId] + ".css";
};